import { Card, Column, Form, Input, Row } from '@bancobarigui/barihaus';
import { MaskedInput } from '@/shared/components/MaskedInput';

type Props = {
  inspector?: boolean;
};

export function UserInfoForm({ inspector = false }: Props) {
  return (
    <Card>
      <Row gutter={[24, 16]}>
        <Column span={12}>
          <Form.Item
            label="Nome"
            name="name"
            rules={[{ required: true, message: 'Informe o nome completo do usuário' }]}
          >
            <Input />
          </Form.Item>
        </Column>

        <Column span={12}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Informe o email do usuário' },
              { type: 'email', message: 'Informe um email válido.' },
            ]}
          >
            <Input />
          </Form.Item>
        </Column>

        <Column span={12}>
          <Form.Item
            label="Telefone"
            name="phone"
            rules={[{ required: true, message: 'Informe o telefone do usuário' }]}
          >
            <MaskedInput mask="+55 (00) 00000-0000" placeholder="+55 (XX) XXXX-XXXX" />
          </Form.Item>
        </Column>

        {inspector && (
          <Column span={12}>
            <Form.Item
              label="CPF"
              name="cpf"
              rules={[{ required: true, message: 'Informe o CPF do usuário' }]}
            >
              <MaskedInput mask="000.000.000-00" placeholder="XXX.XXX.XXX-XX" />
            </Form.Item>
          </Column>
        )}

        {inspector && (
          <Column span={12}>
            <Form.Item label="Código de integração" name="integrationCode">
              <Input />
            </Form.Item>
          </Column>
        )}
      </Row>
    </Card>
  );
}
